import { Icon } from '@cbhq/cds-web/icons';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextHeadline } from '@cbhq/cds-web/typography';

import { PaymentMethod } from ':cloud/types/service_proto';
import { PaymentMethodDisplayer } from ':cloud/widgets/billing/PaymentMethodDisplayer';

import { FieldCopy } from './FieldCopy';

export function FreeTrialField() {
  return (
    <HStack
      spacingStart={3}
      spacingEnd={7}
      spacingVertical={1}
      justifyContent="space-between"
      alignItems="center"
      borderRadius="rounded"
      background="backgroundAlternate"
      gap={2}
    >
      <HStack gap={3} alignItems="center">
        <Icon name="giftCard" size="l" color="foreground" />
        <VStack>
          <TextHeadline as="p">$100 in free credits</TextHeadline>
          <TextBody as="p" color="foregroundMuted">
            Applied to your organization
          </TextBody>
        </VStack>
      </HStack>
      <Icon name="checkmark" size="m" />
    </HStack>
  );
}

interface PaymentMethodFieldProps {
  paymentMethod?: PaymentMethod;
  onReplaceCardClick?: React.MouseEventHandler<HTMLInputElement>;
}

export function PaymentMethodField({ paymentMethod }: PaymentMethodFieldProps) {
  return (
    <>
      <FieldCopy
        title="Payment method"
        description="Your free credits will be used to pay for the applicable Developer Platform service and we will notify you of your credit balance in advance of its expiration. Your alternate payment method on file will be charged upon expiration of your free credits.*"
      />
      <VStack gap={3}>
        <FreeTrialField />
        {paymentMethod && <PaymentMethodDisplayer paymentMethod={paymentMethod} />}
      </VStack>
      3
    </>
  );
}
